import React, { useRef } from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PhotoGallery = () => {
  const { t } = useLang();
  const scrollRef = useRef(null);

  const photos = [
    '/images/gallery/WhatsApp Image 2026-07-02 at 16.47.39.jpeg',
    '/images/gallery/IMG_8965.jpg',
    '/images/gallery/IMG_8966.jpg',
    '/images/gallery/IMG_8967.jpg',
    '/images/gallery/IMG_8968.jpg',
    '/images/gallery/IMG_8969.jpg',
    '/images/gallery/IMG_8970.jpg',
    '/images/gallery/IMG_8971.jpg',
    '/images/gallery/IMG_2979.jpg',
    '/images/gallery/IMG_3001.jpg',
    '/images/gallery/IMG_3160.jpg',
    '/images/gallery/IMG_3161.jpg',
    '/images/gallery/IMG_3319.jpg',
    '/images/gallery/IMG_3323.jpg',
    '/images/gallery/IMG_3331.jpg',
    '/images/gallery/IMG_3350.jpg'
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -400 : 400;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section id="gallery" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div className="max-w-2xl">
            <h2 className="text-[13px] uppercase tracking-[0.2em] text-brand-primary font-bold mb-3">
              {t.gallery.kicker}
            </h2>
            <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">
              {t.gallery.title}
            </h3>
            <p className="text-lg text-slate-600">
              {t.gallery.subtitle}
            </p>
          </div>
          <div className="flex gap-3 mt-6 md:mt-0">
            <button
              onClick={() => scroll('left')}
              className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-brand-primary hover:text-white hover:border-brand-primary transition-all"
              aria-label="Anterior"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-brand-primary hover:text-white hover:border-brand-primary transition-all"
              aria-label="Siguiente"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      <div className="w-full relative px-4 sm:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-12 pt-4 [&::-webkit-scrollbar]:hidden"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {photos.map((src, idx) => (
            <div
              key={idx}
              className="relative w-[85vw] sm:w-[400px] aspect-[3/4] shrink-0 snap-center rounded-[2rem] overflow-hidden bg-slate-100 group shadow-sm hover:shadow-2xl transition-all duration-500"
            >
              <img
                src={src}
                alt={`Academy Gallery ${idx}`}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700 ease-in-out"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-brand-primary/0 group-hover:bg-brand-primary/10 transition-colors duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhotoGallery;
